import { Link } from "wouter";

interface CTAProps {
  title?: string;
  description?: string;
  /** Text of the button, which goes to the contact page. */
  buttonLabel?: string;
}

/** Closing call-to-action, as in the redesign mockup. */
export function CTA({
  title = "Ready to Talk?",
  description = "Tell us about your hiring or project requirement and we'll get back to you with next steps.",
  buttonLabel = "Talk to Our Team",
}: CTAProps) {
  return (
    <section id="contact" className="dc" style={{ background: "#070B16", padding: "120px 0 96px" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 32px" }}>
        <div className="cta-ring rv">
          <div style={{ position: "relative", overflow: "hidden", borderRadius: "27px", background: "#0B1222", padding: "clamp(48px, 8vw, 104px) clamp(28px, 6vw, 80px)", textAlign: "center" }}>
            <div className="grid-bg" aria-hidden="true" style={{ position: "absolute", inset: "0", WebkitMaskImage: "radial-gradient(ellipse 60% 70% at 50% 50%, #000 20%, transparent 75%)", maskImage: "radial-gradient(ellipse 60% 70% at 50% 50%, #000 20%, transparent 75%)" }}></div>
            <div style={{ position: "relative" }}>
              <h2 style={{ fontFamily: "Sora, sans-serif", fontWeight: "600", fontSize: "clamp(2.4rem, 5.2vw, 4.4rem)", letterSpacing: "-0.035em", lineHeight: "1.05", margin: "0", color: "#fff" }}>{title}</h2>
              <p style={{ margin: "22px auto 0", maxWidth: "560px", fontSize: "18px", lineHeight: "1.65", color: "#A9B2C5" }}>{description}</p>
              <Link className="btn btn-p" href="/contact" style={{ marginTop: "38px", padding: "18px 32px", borderRadius: "999px", fontWeight: "600", fontSize: "16px" }}>{buttonLabel} <svg className="ar" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
